import React from 'react';
export function ShareIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.694 8.684l2.3-2.289-.014 9.586a1.001 1.001 0 001.707.707 1 1 0 00.293-.707l.011-9.58 2.289 2.3a1.003 1.003 0 001.42-1.419l-4-4.006a1 1 0 00-1.414 0L7.282 7.268a1 1 0 001.412 1.416z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.984 10.994a1 1 0 00-1 1l-.009 6a1 1 0 01-1 1l-12-.017a1 1 0 01-1-1l.009-6a1 1 0 10-2 0l-.009 6a3 3 0 003 3l12 .017h.006a3 3 0 003-3l.009-6a1 1 0 00-1.006-1z"
  }));
}